// extracted by mini-css-extract-plugin
module.exports = {"advertiseCardBox":"style_advertiseCardBox__GXfZ1","icon":"style_icon__d4MjM","advertiseTitle":"style_advertiseTitle__UxYat","advertisedesc":"style_advertisedesc__sm8b7"};